import { useState, useMemo } from 'react'

export type RevealPhase =
  | 'initial'
  | 'aiSummaryReasoning'
  | 'aiSummary'
  | 'personReasoning'
  | 'personAnalysis'
  | 'locationReasoning'
  | 'locationAnalysis'
  | 'videoReasoning'
  | 'videoSubsections'
  | 'videoPlayer'
  | 'complete'

const PHASE_ORDER: RevealPhase[] = [
  'initial', 'aiSummaryReasoning', 'aiSummary', 'personReasoning',
  'personAnalysis', 'locationReasoning', 'locationAnalysis',
  'videoReasoning', 'videoSubsections', 'videoPlayer', 'complete'
]

interface UseRevealPhasesReturn {
  revealPhase: RevealPhase
  setRevealPhase: (phase: RevealPhase) => void
  isPhaseReached: (phase: RevealPhase) => boolean
  isLoadingComplete: boolean
}

export const useRevealPhases = (): UseRevealPhasesReturn => {
  const [revealPhase, setRevealPhase] = useState<RevealPhase>('initial')

  const currentPhaseIndex = useMemo(
    () => PHASE_ORDER.indexOf(revealPhase),
    [revealPhase]
  )

  const isPhaseReached = useMemo(
    () => (phase: RevealPhase) => currentPhaseIndex >= PHASE_ORDER.indexOf(phase),
    [currentPhaseIndex]
  )

  const isLoadingComplete = useMemo(
    () => revealPhase === 'videoPlayer' || revealPhase === 'complete',
    [revealPhase]
  )

  return {
    revealPhase,
    setRevealPhase,
    isPhaseReached,
    isLoadingComplete
  }
}
